import {
  createProtocolWebService,
  createProtocolWebEditorService,
  setPanicHandler,
  setTraceHandler,
  type PanicInfo,
  type ProtocolWebService,
  type ProtocolWebEditorService,
} from '@castoredc/castor_prose';
import { logger } from 'features/logger/logger';
import { RoutePath } from 'features/routing/constants';
import { markIntentionalNavigation } from 'shared/utils/intentionalNavigationGuard';
import { getProsePanicked, setProsePanicked } from './prosePanicState';
import { handleProseTraces } from './proseTraceHandler';
import type { store } from 'features/store/store';

let boundStore: typeof store | null = null;

function readQuestionnaireIdFromState(): string | null {
  return boundStore?.getState().questionnaire.docData?.id ?? null;
}

function handleProsePanic(panicInfo: PanicInfo): void {
  if (getProsePanicked()) return;
  setProsePanicked(true);

  const questionnaireId = readQuestionnaireIdFromState();

  logger.error(
    'PROSE WASM panic',
    { details: { panicInfo, questionnaireId } },
    new Error(panicInfo.message)
  );

  markIntentionalNavigation();
  window.location.assign(RoutePath.SomethingWentWrong);
}

export const initProseServiceFactory = (reduxStore: typeof store): void => {
  boundStore = reduxStore;
  setPanicHandler(handleProsePanic);
  setTraceHandler(handleProseTraces);
};

let protocolServiceLoad: Promise<ProtocolWebService> | undefined;
let protocolEditorServiceLoad: Promise<ProtocolWebEditorService> | undefined;

// A failed load stays cached: castor_prose keeps a rejected WASM init, so a
// retry before a page reload cannot succeed.
export function getProtocolService(): Promise<ProtocolWebService> {
  protocolServiceLoad ??= createProtocolWebService();
  return protocolServiceLoad;
}

export function getProtocolEditorService(): Promise<ProtocolWebEditorService> {
  protocolEditorServiceLoad ??= createProtocolWebEditorService();
  return protocolEditorServiceLoad;
}
